<template>
  <div class="container-fluid page-content">
    <register-product-step3></register-product-step3>
  </div>
</template>

<script>
  import RegisterProductStep3 from '@/components/registerStep3'
  import scrollToElement from 'scroll-to-element'
  
  export default {
    name: 'ProductRegistrationStep3',
    mounted () {
      scrollToElement('.page-content', {
        offset: 0,
        ease: 'out-cube',
        duration: 800
      });
    },
    components: {
      RegisterProductStep3
    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    padding-top: 50px;
    padding-bottom: 50px;
  }
</style>
